(function(){

  function injectRdvDot(){
    document.querySelectorAll('.tw-menu-title span.tw-grow').forEach(function(span){
      if(
        span.textContent.includes('EN DIRECT') &&
        !span.querySelector('.rdv-pulse-dot')
      ){
        span.innerHTML = span.innerHTML.replace(
          '🔴',
          '<span class="rdv-pulse-dot" aria-hidden="true"></span>'
        );
      }
    });
  }

  function fixZIndex(){
    document.querySelectorAll('.rdv-pulse-dot').forEach(function(dot){
      var el = dot;
      var zVal = 50;
      while(el){
        var tag = el.tagName ? el.tagName.toLowerCase() : '';
        var cls = el.className || '';
        if(
          cls.includes('sidebar') ||
          cls.includes('tw-drawer') ||
          cls.includes('tw-p-6') ||
          tag === 'body'
        ){ break; }
        el.style.overflow = 'visible';
        el.style.zIndex   = zVal;
        if(!el.style.position || el.style.position === 'static'){
          el.style.position = 'relative';
        }
        if(tag === 'ul' && cls.includes('tw-menu')){ break; }
        el = el.parentElement;
        zVal--;
      }
    });
  }

  function run(){
    injectRdvDot();
    fixZIndex();
  }

  run();
  var observer = new MutationObserver(run);
  observer.observe(document.body, { childList: true, subtree: true });

})();

if (window.location.pathname.startsWith('/a/members')) {

  /* ================================================================
     SEUL BLOC A MODIFIER pour les semaines sans direct
     ================================================================ */

  var EXCEPTION_ENABLED    = true;
  var EXCEPTION_DATE_START = '2026-06-18';
  var EXCEPTION_DATE_END   = '2026-06-25';
  var EXCEPTION_BADGE_BG   = '#1D4ED8';
  var EXCEPTION_DOT_COLOR  = '#FFFFFF';      // couleur du dot + pulse sur le timer
  var EXCEPTION_BADGE_TEXT = 'PAS DE DIRECT CETTE SEMAINE';
  var EXCEPTION_MENU_TEXT  = 'PAS DE DIRECT - SAINT-JEAN';
  var EXCEPTION_MSG        = 'Conge Saint-Jean - Un pre-enregistre + 2 recettes fetes vous attendent des mercredi!';
  var EXCEPTION_CARD_MSG   = 'Conge Saint-Jean — contenu disponible des mercredi!';  // texte sur la carte formation

  /* ================================================================ */

  function isExceptionActive() {
    if (!EXCEPTION_ENABLED) return false;
    var now   = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' }));
    var start = new Date(EXCEPTION_DATE_START + 'T00:00:00');
    var end   = new Date(EXCEPTION_DATE_END   + 'T23:59:59');
    return now >= start && now <= end;
  }

  function injectAtelierDot() {
    document.querySelectorAll('.tw-menu-title span.tw-grow').forEach(function(span) {
      if (!span.textContent.toLowerCase().includes('ateliers virtuels en direct')) return;
      if (!span.querySelector('.rdv-pulse-dot')) {
        span.innerHTML = span.innerHTML.replace(
          '🔴',
          '<span class="rdv-pulse-dot" aria-hidden="true"></span>'
        );
      }
    });
  }

  function injectRdvDot() {
    document.querySelectorAll('.tw-menu-title span.tw-grow').forEach(function(span) {
      // Cibler UNIQUEMENT le span du menu RENDEZ-VOUS GOURMAND
      if (!span.textContent.includes('RENDEZ-VOUS GOURMAND')) return;

      // Injecter le dot une seule fois
      if (!span.querySelector('.rdv-pulse-dot')) {
        span.innerHTML = span.innerHTML.replace(
          '🔴',
          '<span class="rdv-pulse-dot" aria-hidden="true"></span>'
        );
      }

      // Couleur du dot + pulse selon le mode exception
      var dot = span.querySelector('.rdv-pulse-dot');
      if (dot) {
        if (isExceptionActive()) {
          dot.style.background = EXCEPTION_DOT_COLOR;
          dot.style.boxShadow  = '0 0 8px ' + EXCEPTION_DOT_COLOR + ', 0 0 18px ' + EXCEPTION_DOT_COLOR;
          var styleId = 'rdv-pulse-exception-style';
          if (!document.getElementById(styleId)) {
            var s = document.createElement('style');
            s.id = styleId;
            document.head.appendChild(s);
          }
          document.getElementById(styleId).textContent =
            '.rdv-pulse-dot::after { background: ' + EXCEPTION_DOT_COLOR + ' !important; }';
        } else {
          dot.style.background = '';
          dot.style.boxShadow  = '';
          var styleEl = document.getElementById('rdv-pulse-exception-style');
          if (styleEl) styleEl.textContent = '';
        }
      }

      // Trouver ou creer le label de texte
      var label = span.querySelector('.rdv-menu-label');
      if (!label) {
        span.childNodes.forEach(function(node) {
          if (node.nodeType === 3 && node.textContent.trim()) {
            var l = document.createElement('span');
            l.className = 'rdv-menu-label';
            l.dataset.original = node.textContent.trim();
            l.textContent = node.textContent;
            span.replaceChild(l, node);
          }
        });
        label = span.querySelector('.rdv-menu-label');
      }

      // Mettre a jour le texte selon le mode
      if (label) {
        if (!label.dataset.original) label.dataset.original = label.textContent.trim();
        label.textContent = isExceptionActive()
          ? EXCEPTION_MENU_TEXT
          : label.dataset.original;
      }
    });
  }

  function fixZIndex() {
    document.querySelectorAll('.rdv-pulse-dot').forEach(function(dot) {
      var el = dot;
      var zVal = 50;
      while (el) {
        var tag = el.tagName ? el.tagName.toLowerCase() : '';
        var cls = el.className || '';
        if (
          cls.includes('sidebar') ||
          cls.includes('tw-drawer') ||
          cls.includes('tw-p-6') ||
          tag === 'body'
        ) { break; }
        el.style.overflow = 'visible';
        el.style.zIndex = zVal;
        if (!el.style.position || el.style.position === 'static') {
          el.style.position = 'relative';
        }
        if (tag === 'ul' && cls.includes('tw-menu')) { break; }
        el = el.parentElement;
        zVal--;
      }
    });
  }

  /* ================================================================
     AUTO-INJECT TIMER — <div data-dc-live-timer></div>
     Colle ce tag HTML n'importe où dans Tevello pour afficher
     le timer automatiquement, sans dupliquer le code.
     ================================================================ */

  function setupInlineTimers() {
    document.querySelectorAll('[data-dc-live-timer]').forEach(function(el) {
      if (el.dataset.dcTimerReady) return;
      el.dataset.dcTimerReady = '1';

      el.innerHTML =
        '<div class="dc-live-card js-dc-live-card-auto dc-mode-countdown">' +
          '<div class="dc-live-badge" aria-live="polite">' +
            '<span class="dc-dot-auto" aria-hidden="true"></span>' +
            '<span class="dc-badge-text-auto">EN DIRECT</span>' +
          '</div>' +
          '<div class="dc-since-auto" style="display:none;font-size:12px;letter-spacing:.6px;text-transform:uppercase;opacity:.6;margin-top:-4px;"></div>' +
          '<div class="dc-timer-auto" style="display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:flex-end!important;justify-content:center!important;gap:18px;font-family:system-ui;width:100%;">' +
            '<div style="display:flex!important;flex-direction:column!important;align-items:center!important;min-width:72px;"><div class="dc-num-auto dc-d" style="font-weight:900;font-size:44px;line-height:1;font-variant-numeric:tabular-nums;">00</div><div style="margin-top:6px;font-size:11px;letter-spacing:1.3px;opacity:.7;text-transform:uppercase;">Jours</div></div>' +
            '<div style="display:flex!important;flex-direction:column!important;align-items:center!important;min-width:72px;"><div class="dc-num-auto dc-h" style="font-weight:900;font-size:44px;line-height:1;font-variant-numeric:tabular-nums;">00</div><div style="margin-top:6px;font-size:11px;letter-spacing:1.3px;opacity:.7;text-transform:uppercase;">Heures</div></div>' +
            '<div style="display:flex!important;flex-direction:column!important;align-items:center!important;min-width:72px;"><div class="dc-num-auto dc-m" style="font-weight:900;font-size:44px;line-height:1;font-variant-numeric:tabular-nums;">00</div><div style="margin-top:6px;font-size:11px;letter-spacing:1.3px;opacity:.7;text-transform:uppercase;">Minutes</div></div>' +
            '<div style="display:flex!important;flex-direction:column!important;align-items:center!important;min-width:72px;"><div class="dc-num-auto dc-s" style="font-weight:900;font-size:44px;line-height:1;font-variant-numeric:tabular-nums;">00</div><div style="margin-top:6px;font-size:11px;letter-spacing:1.3px;opacity:.7;text-transform:uppercase;">Secondes</div></div>' +
          '</div>' +
          '<div class="dc-ex-msg-auto" style="display:none;font-size:15px;font-weight:600;text-align:center;line-height:1.5;max-width:600px;"></div>' +
        '</div>';

      // Styles de base injectés une seule fois
      if (!document.getElementById('dc-auto-timer-style')) {
        var s = document.createElement('style');
        s.id = 'dc-auto-timer-style';
        s.textContent =
          '.dc-live-card{display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:16px;padding:20px 18px;border-radius:20px;width:100%;max-width:860px;margin:0 auto;}' +
          '.dc-timer-auto{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:flex-end!important;justify-content:center!important;gap:18px;}' +
          '.dc-timer-auto > div{display:flex!important;flex-direction:column!important;align-items:center!important;}' +
          '.dc-live-badge{display:inline-flex;align-items:center;gap:10px;padding:10px 18px;border-radius:999px;font:800 15px/1 system-ui;text-transform:uppercase;letter-spacing:.4px;background:#0F172A;color:#fff;transition:background .3s;}' +
          '.dc-dot-auto{width:14px;height:14px;border-radius:50%;position:relative;flex:0 0 auto;background:#3DFF7A;box-shadow:0 0 10px #3DFF7A,0 0 22px #3DFF7A;overflow:visible;}' +
          '.dc-dot-auto::after{content:"";position:absolute;top:50%;left:50%;width:100%;height:100%;border-radius:50%;transform:translate(-50%,-50%) scale(1);background:#3DFF7A;opacity:.65;animation:dcPulseAuto 1.4s ease-out infinite;}' +
          '@keyframes dcPulseAuto{0%{transform:translate(-50%,-50%) scale(1);opacity:.9}70%{transform:translate(-50%,-50%) scale(3.2);opacity:.25}100%{transform:translate(-50%,-50%) scale(3.8);opacity:0}}' +
          '.dc-num-auto{color:#0F172A;}';
        document.head.appendChild(s);
      }

      var TZ = 'America/Toronto';
      var pad = function(n){ return String(n).padStart(2,'0'); };

      function nowInTZ(){ return new Date(new Date().toLocaleString('en-US',{timeZone:TZ})); }

      function getNextStart(now){
        var t = new Date(now);
        var diff = (3 - now.getDay() + 7) % 7;
        t.setDate(now.getDate() + diff);
        t.setHours(19, 0, 0, 0);
        var end = new Date(t); end.setHours(20, 0, 0, 0);
        if (now >= end) t.setDate(t.getDate() + 7);
        return t;
      }

      var badge   = el.querySelector('.dc-badge-text-auto');
      var since   = el.querySelector('.dc-since-auto');
      var timerEl = el.querySelector('.dc-timer-auto');
      var exMsg   = el.querySelector('.dc-ex-msg-auto');
      var dot     = el.querySelector('.dc-dot-auto');
      var dEl = el.querySelector('.dc-d');
      var hEl = el.querySelector('.dc-h');
      var mEl = el.querySelector('.dc-m');
      var sEl = el.querySelector('.dc-s');
      var liveBadge = el.querySelector('.dc-live-badge');

      function applyExceptionStyle(){
        liveBadge.style.background = EXCEPTION_BADGE_BG;
        dot.style.background   = EXCEPTION_DOT_COLOR;
        dot.style.boxShadow    = '0 0 10px ' + EXCEPTION_DOT_COLOR + ',0 0 22px ' + EXCEPTION_DOT_COLOR;
        var styleId = 'dc-dot-auto-ex-style';
        if (!document.getElementById(styleId)){
          var s2 = document.createElement('style'); s2.id = styleId; document.head.appendChild(s2);
        }
        document.getElementById(styleId).textContent =
          '@keyframes dcPulseAuto{0%{transform:translate(-50%,-50%) scale(1);opacity:.9}70%{transform:translate(-50%,-50%) scale(3.2);opacity:.25}100%{transform:translate(-50%,-50%) scale(3.8);opacity:0}}' +
          '.dc-dot-auto{background:' + EXCEPTION_DOT_COLOR + '!important;box-shadow:0 0 10px ' + EXCEPTION_DOT_COLOR + ',0 0 22px ' + EXCEPTION_DOT_COLOR + '!important;}' +
          '.dc-dot-auto::after{background:' + EXCEPTION_DOT_COLOR + '!important;animation:dcPulseAuto 1.4s ease-out infinite!important;animation-play-state:running!important;}';
      }

      function resetStyle(){
        liveBadge.style.background = '';
        dot.style.background = '';
        dot.style.boxShadow  = '';
        var styleEl = document.getElementById('dc-dot-auto-ex-style');
        if (styleEl) styleEl.textContent = '';
      }

      function tick(){
        var now = nowInTZ();

        // EXCEPTION
        if (isExceptionActive()){
          applyExceptionStyle();
          if (badge)   badge.textContent = EXCEPTION_BADGE_TEXT;
          if (timerEl) timerEl.style.display = 'none';
          if (since)   since.style.display = 'none';
          if (exMsg)   { exMsg.textContent = EXCEPTION_MSG; exMsg.style.display = 'block'; }
          return;
        }

        resetStyle();
        if (timerEl) timerEl.style.display = '';
        if (exMsg)   exMsg.style.display = 'none';

        var start = getNextStart(now);
        var end   = new Date(start); end.setHours(20,0,0,0);
        var pre   = new Date(start.getTime() - 15*60000);

        if (now >= start && now < end){
          liveBadge.style.background = '#B91C1C';
          if (badge) badge.textContent = 'MAINTENANT EN DIRECT';
          if (since) { since.textContent = 'depuis'; since.style.display = 'block'; }
          var e = Math.floor((now - start)/1000);
          dEl.textContent='00'; hEl.textContent=pad(Math.floor(e/3600));
          mEl.textContent=pad(Math.floor((e%3600)/60)); sEl.textContent=pad(e%60);
          return;
        }
        if (now >= pre && now < start){
          liveBadge.style.background = '#B91C1C';
          if (badge) badge.textContent = 'BIENTOT EN DIRECT';
          if (since) { since.textContent = 'débute dans'; since.style.display = 'block'; }
        } else {
          liveBadge.style.background = '#0F172A';
          if (badge) badge.textContent = 'EN DIRECT — MERCREDI 19H';
          if (since) since.style.display = 'none';
        }
        var diff = Math.floor((start - now)/1000);
        dEl.textContent=pad(Math.floor(diff/86400));
        hEl.textContent=pad(Math.floor((diff%86400)/3600));
        mEl.textContent=pad(Math.floor((diff%3600)/60));
        sEl.textContent=pad(diff%60);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  function setupCardTimers() {

    if (!document.querySelector('.courses')) return;

    var TZ = 'America/Toronto';

    function nowInTZ() {
      return new Date(new Date().toLocaleString('en-US', { timeZone: TZ }));
    }

    var pad = function(n) { return String(n).padStart(2, '0'); };

    function getNextTarget(dayOfWeek, hour, minute) {
      var now  = new Date(new Date().toLocaleString('en-US', { timeZone: TZ }));
      var diff = (dayOfWeek - now.getDay() + 7) % 7;
      var t    = new Date(now);
      t.setDate(now.getDate() + diff);
      t.setHours(hour, minute, 0, 0);
      if (now >= t) t.setDate(t.getDate() + 7);
      return t;
    }

    function getEnd(start, durationMinutes) {
      return new Date(start.getTime() + durationMinutes * 60000);
    }

    function injectTimer(card, config) {
      if (card.querySelector('.dc-card-timer')) return;

      var wrap  = document.createElement('div');
      wrap.className = 'dc-card-timer';

      var badge = document.createElement('div');
      badge.className = 'dc-card-badge';

      var dot   = document.createElement('span');
      dot.className = 'dc-card-dot';

      var text  = document.createElement('span');
      text.className = 'dc-card-text';

      var nums  = document.createElement('div');
      nums.className = 'dc-card-nums';

      badge.appendChild(dot);
      badge.appendChild(text);
      wrap.appendChild(badge);
      wrap.appendChild(nums);

      var figure = card.querySelector('figure');
      if (figure) {
        figure.style.position = 'relative';
        figure.appendChild(wrap);
      }

      function tick() {

        // ====== MODE EXCEPTION ======
        if (isExceptionActive()) {
          badge.style.background = EXCEPTION_BADGE_BG;
          dot.style.background   = EXCEPTION_DOT_COLOR;
          dot.style.boxShadow    = '0 0 6px ' + EXCEPTION_DOT_COLOR + ',0 0 14px ' + EXCEPTION_DOT_COLOR;
          // Pulse ::after en blanc
          var cardDotStyleId = 'dc-card-dot-ex-style';
          if (!document.getElementById(cardDotStyleId)) {
            var sd = document.createElement('style');
            sd.id = cardDotStyleId;
            document.head.appendChild(sd);
          }
          document.getElementById(cardDotStyleId).textContent =
            '.dc-card-dot::after{background:' + EXCEPTION_DOT_COLOR + '!important;}';
          text.textContent = EXCEPTION_BADGE_TEXT;
          nums.textContent = EXCEPTION_CARD_MSG;
          return;
        }
        // Reset dot en mode normal
        dot.style.background = '';
        dot.style.boxShadow  = '';
        var cardDotStyleEl = document.getElementById('dc-card-dot-ex-style');
        if (cardDotStyleEl) cardDotStyleEl.textContent = '';

        // ====== MODE NORMAL ======
        var now   = nowInTZ();
        var start = getNextTarget(config.day, config.hour, config.minute);
        var end   = getEnd(start, config.duration || 60);
        var pre   = new Date(start.getTime() - 15 * 60000);

        if (now >= start && now < end) {
          badge.style.background = '#B91C1C';
          text.textContent = 'MAINTENANT EN DIRECT';
          var e = Math.floor((now - start) / 1000);
          nums.textContent =
            pad(Math.floor(e / 3600)) + 'h ' +
            pad(Math.floor((e % 3600) / 60)) + 'm ' +
            pad(e % 60) + 's';
          return;
        }

        if (now >= pre && now < start) {
          badge.style.background = '#B91C1C';
          text.textContent = 'BIENTOT EN DIRECT';
        } else {
          badge.style.background = '#0F172A';
          text.textContent = config.label;
        }

        var diff = Math.floor((start - now) / 1000);
        nums.textContent =
          Math.floor(diff / 86400) + 'j ' +
          pad(Math.floor((diff % 86400) / 3600)) + 'h ' +
          pad(Math.floor((diff % 3600) / 60)) + 'm ' +
          pad(diff % 60) + 's';
      }

      tick();
      setInterval(tick, 1000);
    }

    // Cercle Gourmand - mercredi 19h
    var cercleCard = document.querySelector(
      '.tw-card[data-id="022cffb4-4d7c-4b27-a3d6-5c28d3be9761"]'
    );
    if (cercleCard) {
      injectTimer(cercleCard, {
        day: 3, hour: 19, minute: 0, duration: 60,
        label: 'EN DIRECT - MERCREDI 19H'
      });
    }

    // ================================================================
    // Ateliers virtuels — jeudi 23 juillet et 30 juillet 18h
    // PAS d'exception appliquée sur ces timers
    // ================================================================
    var ATELIER_DATES = [
      new Date('2026-07-23T18:00:00'),
      new Date('2026-07-30T18:00:00')
    ];
    var ATELIER_DURATION = 120; // minutes

    function getNextAtelierStart() {
      var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' }));
      for (var i = 0; i < ATELIER_DATES.length; i++) {
        var start = ATELIER_DATES[i];
        var end   = new Date(start.getTime() + ATELIER_DURATION * 60000);
        if (now < end) return { start: start, end: end };
      }
      return null; // tous les ateliers sont passés
    }

    function injectAtelierTimer(card) {
      if (card.querySelector('.dc-card-timer')) return;

      var wrap  = document.createElement('div'); wrap.className = 'dc-card-timer';
      var badge = document.createElement('div'); badge.className = 'dc-card-badge';
      var dot   = document.createElement('span'); dot.className = 'dc-card-dot';
      var text  = document.createElement('span'); text.className = 'dc-card-text';
      var nums  = document.createElement('div'); nums.className = 'dc-card-nums';

      badge.appendChild(dot);
      badge.appendChild(text);
      wrap.appendChild(badge);
      wrap.appendChild(nums);

      var figure = card.querySelector('figure');
      if (figure) { figure.style.position = 'relative'; figure.appendChild(wrap); }

      function tick() {
        var next = getNextAtelierStart();
        if (!next) {
          badge.style.background = '#0F172A';
          text.textContent = 'ATELIER TERMINÉ';
          nums.textContent = '';
          return;
        }

        var now   = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' }));
        var start = next.start;
        var end   = next.end;
        var pre   = new Date(start.getTime() - 15 * 60000);

        if (now >= start && now < end) {
          badge.style.background = '#B91C1C';
          text.textContent = 'MAINTENANT EN DIRECT';
          var e = Math.floor((now - start) / 1000);
          nums.textContent =
            pad(Math.floor(e / 3600)) + 'h ' +
            pad(Math.floor((e % 3600) / 60)) + 'm ' +
            pad(e % 60) + 's';
          return;
        }
        if (now >= pre && now < start) {
          badge.style.background = '#B91C1C';
          text.textContent = 'BIENTOT EN DIRECT';
        } else {
          badge.style.background = '#0F172A';
          // Afficher la date du prochain atelier
          var opts = { weekday:'long', day:'numeric', month:'long' };
          var dateStr = start.toLocaleDateString('fr-CA', opts).toUpperCase();
          text.textContent = 'EN DIRECT — ' + dateStr + ', 18H';
        }
        var diff = Math.floor((start - now) / 1000);
        nums.textContent =
          Math.floor(diff / 86400) + 'j ' +
          pad(Math.floor((diff % 86400) / 3600)) + 'h ' +
          pad(Math.floor((diff % 3600) / 60)) + 'm ' +
          pad(diff % 60) + 's';
      }

      tick();
      setInterval(tick, 1000);
    }

    /*// ================================================================
    // Carte Atelier BBQ — data-id fixe, dates fixes, pas d'exception
    // Pour changer les dates futures: modifie ATELIER_DATES ci-haut
    // ================================================================
    var atelierCard = document.querySelector(
      '.tw-card[data-id="4bb3fd89-7c0d-4643-a101-afc5b076cdb1"]'
    );
    if (atelierCard) {
      injectAtelierTimer(atelierCard);
    }*/

    /* Mel Prep - mardi 18h
    var melCard = document.querySelector(
      '.tw-card[data-id="df31dea9-660e-40d6-9049-0550f93fbf76"]'
    );
    if (melCard) {
      injectTimer(melCard, {
        day: 2, hour: 18, minute: 0, duration: 60,
        label: 'EN DIRECT - MARDI 18H'
      });
    }*/
  }

  function runAll() {
    injectRdvDot();
    injectAtelierDot();
    fixZIndex();
    setupCardTimers();
    setupInlineTimers();
  }

  runAll();

  var _tevelloObserver = new MutationObserver(runAll);
  _tevelloObserver.observe(document.body, { childList: true, subtree: true });

} // fin de la garde /a/members